import container from '../container/container';
import preloader from '../preloader/preloader';

const sliderList = function (id) {
    let publicVars = {};
    const privateVars = {
        name: 'slider-list(' + id + ')',
        itemsCount: 0,
        firstItem: 0,
        lastItem: 0,
        itemWidth: 0,
        isAnimating: false,
        touchStart: 0,
        touchDiff: 0,
        touchStartY: 0,
        touchDiffY: 0,
        touchStarted: false
    };

    const methods = {
        init: (options) => {
            container.msg(privateVars.name, 'init');

            publicVars = container.performCopy(publicVars, options);

            preloader.init();

            methods.bind();

            methods.startup();

            methods.preloadImages();
        },

        bind: function () {
            let resizeRAF;

            document.querySelector(publicVars.cssId.arrowLeftId).addEventListener('click', function (event) {
                container.msg(privateVars.name, 'arrow left click');

                methods.actionMoveSlider('left');
            });

            document.querySelector(publicVars.cssId.arrowRightId).addEventListener('click', function (event) {
                container.msg(privateVars.name, 'arrow right click');

                methods.actionMoveSlider('right');
            });

            window.addEventListener('resize', function () {
                cancelAnimationFrame(resizeRAF);

                resizeRAF = requestAnimationFrame(function () {
                    methods.handleWindowResize();
                });
            });

            window.addEventListener('orientationchange', function () {
                cancelAnimationFrame(resizeRAF);

                resizeRAF = requestAnimationFrame(function () {
                    methods.handleWindowResize();
                });
            });

            document.querySelector(publicVars.cssId.containerTouchId).addEventListener('touchstart', function (event) {

                if (event.target.closest(publicVars.cssId.arrowLeftId) || event.target.closest(publicVars.cssId.arrowRightId)) {
                    // If it is, return early to prevent the rest of the code from executing
                    return;
                }

                if (privateVars.touchStarted || privateVars.isAnimating) {
                    return;
                }

                privateVars.touchStart = event.touches[0].clientX;
                privateVars.touchStartY = event.touches[0].clientY;

                privateVars.touchStarted = true;
            });

            document.querySelector(publicVars.cssId.containerTouchId).addEventListener('touchmove', function (event) {
                if (privateVars.touchStarted && !privateVars.isAnimating) {
                    privateVars.touchDiff = event.touches[0].clientX - privateVars.touchStart;
                    privateVars.touchDiffY = event.touches[0].clientY - privateVars.touchStartY;

                    methods.handleTouchMove(privateVars.touchDiff, privateVars.touchDiffY);
                }
            });

            document.querySelector(publicVars.cssId.containerTouchId).addEventListener('touchend', function (event) {
                methods.handleTouchEnd();
            });
        },

        startup: function () {
            privateVars.itemsCount = document.querySelectorAll(publicVars.cssId.itemCls).length;
            container.msg(privateVars.name, 'items count: ' + privateVars.itemsCount);

            const {first, last, itemWidth} = methods.calculateCurrentItemsState();

            privateVars.firstItem = first;
            privateVars.lastItem = last;
            privateVars.itemWidth = itemWidth;

            methods.handleArrowsState();
        },

        preloadImages: function () {

        },

        actionMoveSlider: function (direction) {

            if (privateVars.isAnimating) {
                return;
            }

            if (direction === 'left') {
                if (privateVars.firstItem > 1) {
                    privateVars.firstItem--;
                    privateVars.lastItem--;
                } else {
                    return;
                }
            } else {
                if (privateVars.lastItem < privateVars.itemsCount) {
                    privateVars.firstItem++;
                    privateVars.lastItem++;
                } else {
                    return;
                }
            }

            privateVars.isAnimating = true;

            methods.handleArrowsState();

            const translate3dX = -((privateVars.firstItem - 1) * privateVars.itemWidth);

            const containerElement = document.querySelector(publicVars.cssId.containerId);

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    containerElement.style.transform = 'translate3d(' + translate3dX + 'px, 0, 0)';
                });
            });

            containerElement.addEventListener('transitionend', function (event) {
                privateVars.isAnimating = false;
            }, {once: true});
        },

        handleTouchMove: function (diff, diffY) {

            if (Math.abs(diffY) < 100 && Math.abs(diffY) < Math.abs(diff)) {
                const containerElement = document.querySelector(publicVars.cssId.containerId);

                const translate3dX = -((privateVars.firstItem - 1) * privateVars.itemWidth);

                const newTranslate3dX = parseInt(translate3dX) + parseInt(diff);

                containerElement.style.transition = 'none';
                containerElement.style.transform = 'translate3d(' + newTranslate3dX + 'px, 0, 0)';

            }

        },

        cleanupTouchValues: function () {
            privateVars.touchStart = 0;
            privateVars.touchDiff = 0;
            privateVars.touchStartY = 0;
            privateVars.touchDiffY = 0;
        },

        handleTouchEnd: function () {

            if (privateVars.touchStarted && !privateVars.isAnimating) {
                let [translate3dX] = methods.getTranslate3d(document.querySelector(publicVars.cssId.containerId));
                translate3dX = parseInt(translate3dX);

                const containerElement = document.querySelector(publicVars.cssId.containerId);

                function handleTransitionEnd() {
                    privateVars.isAnimating = false;

                    const {first, last, itemWidth} = methods.calculateCurrentItemsState();

                    privateVars.firstItem = first;
                    privateVars.lastItem = last;
                    privateVars.itemWidth = itemWidth;

                    methods.handleArrowsState();

                    methods.cleanupTouchValues();
                }

                const {itemsVisible} = methods.calculateCurrentItemsState();

                if (translate3dX >= 0) {
                    privateVars.touchStarted = false;
                    privateVars.isAnimating = true;

                    if(translate3dX === 0) {
                        handleTransitionEnd();
                        return;
                    }

                    containerElement.style.transition = '';
                    containerElement.style.transform = 'translate3d(0, 0, 0)';

                    containerElement.addEventListener('transitionend', function (event) {
                        handleTransitionEnd();
                    }, {once: true});

                } else if (translate3dX <= -((privateVars.itemsCount - itemsVisible) * privateVars.itemWidth)) {
                    privateVars.touchStarted = false;
                    privateVars.isAnimating = true;

                    containerElement.style.transition = '';
                    containerElement.style.transform = 'translate3d(-' + ((privateVars.itemsCount - itemsVisible) * privateVars.itemWidth) + 'px, 0, 0)';

                    if(translate3dX === -((privateVars.itemsCount - itemsVisible) * privateVars.itemWidth)) {
                        handleTransitionEnd();
                        return;
                    }

                    containerElement.addEventListener('transitionend', function (event) {
                        handleTransitionEnd();
                    }, {once: true});
                } else if (translate3dX < 0 && translate3dX > -((privateVars.itemsCount - itemsVisible) * privateVars.itemWidth)) {
                    privateVars.touchStarted = false;
                    privateVars.isAnimating = true;

                    const translate3dX = -((privateVars.firstItem - 1) * privateVars.itemWidth);

                    // Calculate the number of items moved based on the touch move distance
                    const itemsMoved = Math.round(Math.abs(privateVars.touchDiff) / privateVars.itemWidth);

                    // Calculate the new translate3dX based on the number of items moved
                    let newTranslate3dX = translate3dX;
                    if (privateVars.touchDiff > 0) { // If moving to the right
                        newTranslate3dX += itemsMoved * privateVars.itemWidth;
                    } else { // If moving to the left
                        newTranslate3dX -= itemsMoved * privateVars.itemWidth;
                    }

                    containerElement.style.transition = '';
                    containerElement.style.transform = 'translate3d(' + newTranslate3dX + 'px, 0, 0)';

                    if(translate3dX === newTranslate3dX) {
                        handleTransitionEnd();
                        return;
                    }

                    containerElement.addEventListener('transitionend', function (event) {
                        handleTransitionEnd();
                    }, {once: true});
                } else {
                    privateVars.touchStarted = false;
                    privateVars.isAnimating = false;

                    methods.cleanupTouchValues();
                }

            } else {
                privateVars.touchStarted = false;
                methods.cleanupTouchValues();
            }
        },

        handleWindowResize: function () {
            const {first, last, itemWidth, containerWidth, itemsVisible, isLast} = methods.calculateCurrentItemsState();

            privateVars.firstItem = first;
            privateVars.lastItem = last;
            privateVars.itemWidth = itemWidth;

            if(last - first < (itemsVisible - 1)) {
                privateVars.firstItem = (last - (itemsVisible + 1) > 0) ? (last - itemsVisible + 1) : 1;
            }

            methods.handleArrowsState();

            const translate3dX = -((privateVars.firstItem - 1) * privateVars.itemWidth);

            const containerElement = document.querySelector(publicVars.cssId.containerId);

            containerElement.style.transition = 'none';
            containerElement.style.transform = 'translate3d(' + translate3dX + 'px, 0, 0)';
            containerElement.style.transition = '';
        },

        handleArrowsState: function () {
            if (privateVars.firstItem > 1) {
                document.querySelector(publicVars.cssId.arrowLeftId).classList.remove(publicVars.cssId.arrowDisabledCls.substring(1));
            } else {
                document.querySelector(publicVars.cssId.arrowLeftId).classList.add(publicVars.cssId.arrowDisabledCls.substring(1));
            }

            if (privateVars.lastItem < privateVars.itemsCount) {
                document.querySelector(publicVars.cssId.arrowRightId).classList.remove(publicVars.cssId.arrowDisabledCls.substring(1));
            } else {
                document.querySelector(publicVars.cssId.arrowRightId).classList.add(publicVars.cssId.arrowDisabledCls.substring(1));
            }
        },

        getTranslate3d: function (el) {
            const values = el.style.transform.split(/\w+\(|\);?/);
            if (!values[1] || !values[1].length) {
                return [0, 0, 0];
            }
            return values[1].split(/,\s?/g);
        },

        calculateCurrentItemsState: function () {
            let isLastItem = false;

            const itemWidth = document.querySelector(publicVars.cssId.itemCls).getBoundingClientRect().width;

            container.msg(privateVars.name, 'item width: ' + itemWidth);

            const containerWidth = document.querySelector(publicVars.cssId.containerId).getBoundingClientRect().width;

            container.msg(privateVars.name, 'container width: ' + containerWidth);

            const itemsInContainer = Math.round(containerWidth / itemWidth);

            container.msg(privateVars.name, 'items in container: ' + itemsInContainer);

            const [translate3dXValue] = methods.getTranslate3d(document.querySelector(publicVars.cssId.containerId));

            const currentFirst = Math.round(Math.abs(parseInt(translate3dXValue)) / itemWidth) + 1;

            let currentLast = currentFirst + itemsInContainer - 1;

            if (currentLast > privateVars.itemsCount) {
                currentLast = privateVars.itemsCount;
                isLastItem = true;
            }

            return {
                translate3dXValue: translate3dXValue,
                itemWidth: itemWidth,
                containerWidth: containerWidth,
                first: currentFirst,
                last: currentLast,
                itemsVisible: itemsInContainer,
                isLast: isLastItem
            };
        }
    }

    return {
        init: function (options) {
            methods.init(options);
        }
    }
};

const factory = {
    objId: 0,

    create: function () {
        factory.objId++;

        return sliderList(factory.objId);

    }
}

export default {
    create: factory.create
};